export default __webpack_public_path__ + "static/media/Hellfury Armbands.5ffbddc0.jpg";